import { Component, Input } from "@angular/core";

@Component({
    selector: "m-control-group",
    template: `
        <div [ngClass]="{ 'inputs-group': mode === 'bbwt3', 'm-input-group': mode === 'mipro' }">
            <div [ngClass]="{ 'inputs-group-row': mode === 'bbwt3' }">
                <div
                    [ngClass]="{
                        'inputs-group-row-name': mode === 'bbwt3',
                        'm-input-group-name': mode === 'mipro',
                        'asterisk-mark': required
                    }">
                    {{ label }}:
                </div>
                <div [ngClass]="{ 'inputs-group-row-value': mode === 'bbwt3', 'm-input-group-value': mode === 'mipro' }">
                    <ng-content></ng-content>
                </div>
            </div>
        </div>
    `
})
export class ControlGroupComponent {
    @Input() required = false;
    @Input() label: string;
    @Input() mode: "bbwt3" | "mipro" = "bbwt3";
}
